import {
    FT5_ADD_ACTION_TO_EVENT_TRACKING,
    FT5_ADD_TO_EVENT_TRACKING,
    FT5_EVENT_TRACKING,
    FT5_MOVE_ACTION_TRACKING,
    FT5_MOVE_TRACKING,
    FT5_TRACK_ON_NEXT_PAGE_IMPRESSION,
    FT5_VIEW_FEATURES_TRACKING,
    FT5_VIEW_TRACKING,
} from '../../constants';
import { initializeOProduct } from './product.const';
import { NamedTrackingFeatures, TrackData, TrackingFeatures } from '../../tracking/client/event-data-types';
import { Action, ActionName, DataContainer } from '@otto-ec/tracking-bct';

type withEventMergeId<T> = T & {
    eventMergeId?: string;
};

export function getGlobalEventMergeId(): string | undefined {
    initializeOProduct();
    return o_product.tracking.eventMergeId;
}

export function setGlobalEventMergeId(eventMergeId?: string): void {
    initializeOProduct();
    o_product.tracking.eventMergeId = eventMergeId;
}

export function generateEventMergeId(): string {
    /*              */
    const chars = [
        '0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
        'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm',
        'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z',
        'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M',
        'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'
    ];
    let id = '';
    for (let i = 0; i < 10; i++) {
        const randomIndex = Math.floor(Math.random() * chars.length);
        id += chars[randomIndex];
    }
    return id;
}

export function getGlobalEventMergeIdIfVariationChanged(): string | undefined {
    return o_product.state.isVariationChanged ? getGlobalEventMergeId() : undefined;
}

/**
 *
 */
export function addEventMergeIdIfVariationChangedAndExists<T>(payload: T): withEventMergeId<T> | T {
    const eventMergeId = getGlobalEventMergeIdIfVariationChanged();
    if (eventMergeId !== undefined) {
        return {
            ...payload,
            eventMergeId,
        };
    }

    return payload;
}

/**
 *
 *
 */
export function trackEvent(data: TrackData): void {
    o_global.eventQBus.emit(FT5_EVENT_TRACKING, data);
}

/**
 *
 *
 *
 */
export function trackMoveAction(data: DataContainer, action: Action): void {
    o_global.eventQBus.emit(FT5_MOVE_ACTION_TRACKING, data, action);
}

/**
 *
 *
 */
export function trackMove(data: TrackData): void {
    o_global.eventQBus.emit(FT5_MOVE_TRACKING, data);
}

/**
 *
 *
 *
 */
export function trackAddToEvent(data: TrackData, actionName: ActionName, eventMergeId: string): void {
    o_global.eventQBus.emit(FT5_ADD_TO_EVENT_TRACKING, data, actionName, eventMergeId);
}

/**
 *
 *
 */
export function trackView(data: TrackData): void {
    o_global.eventQBus.emit(FT5_VIEW_TRACKING, data);
}

/**
 *
 *
 */
export function trackViewFeatures(data: TrackingFeatures): void {
    o_global.eventQBus.emit(FT5_VIEW_FEATURES_TRACKING, data);
}

/**
 *
 *
 */
export function trackAddActionToEvent(data: NamedTrackingFeatures, eventMergeId: string): void {
    o_global.eventQBus.emit(FT5_ADD_ACTION_TO_EVENT_TRACKING, data, eventMergeId);
}

export function trackOnNextPageImpression(data: DataContainer): void {
    o_global.eventQBus.emit(FT5_TRACK_ON_NEXT_PAGE_IMPRESSION, data);
}
